/* eslint-disable @typescript-eslint/no-explicit-any */
import { fork, put, takeLatest } from 'redux-saga/effects';
import { getType } from '../../utils';
import actions from './actions';
export function* uploadUserProfilePicture(api, action) {
    const { userId, clientId, formData } = action.payload;
    try {
        yield api
            .uploadProfilePicture({
            userId,
            clientId,
            formData,
        })
            .then((p) => p.request);
        yield put(actions.uploadProfilePictureSuccess());
    }
    catch (error) {
        yield put(actions.uploadProfilePictureError(error));
    }
}
export function* watchUploadUserProfilePicture(api) {
    yield takeLatest(getType(actions.uploadProfilePicture), uploadUserProfilePicture, api);
}
export const userCoreSagas = (api) => [
    fork(watchUploadUserProfilePicture, api),
];
export default userCoreSagas;
